export const T = {
  en_GB: {
    settings: "Settings",
    billing: "Billing & Plans",
    description: "Manage your subscription and billing",
    overview: "Overview",
    invoices: "Invoices",
    sync: "Sync",
    syncError: "Failed to sync subscription",
  },
  nb_NO: {
    settings: "Innstillinger",
    billing: "Fakturering og planer",
    description: "Administrer abonnement og fakturering",
    overview: "Oversikt",
    invoices: "Fakturaer",
    sync: "Synkroniser",
    syncError: "Kunne ikke synkronisere abonnement",
  },
} as const;
